import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import {I18nextProvider} from 'react-i18next';
import i18next from './locales/i18next';
import {CloseButton} from './CloseButton';
import style from './style.module.scss';
import {IFrameFocusManager} from '@learningblocks/shared-components';

ReactModal.setAppElement('#container');

const i18n = i18next;
const changeLang = (lang) => {
  i18n.changeLanguage(lang);
};

/**
 * FullscreenModal:
 *  - Modal window component based on react-modal package
 */
export function FullscreenModal(props) {

  React.useEffect(() => {
    props.lang && changeLang(props.lang);
  }, [props.lang]);

  const renderCloseButton = () =>
    props.closeButton ? (
      <I18nextProvider i18n={i18n}>
        <CloseButton className={props.className} close={props.close} lang={props.lang} />
      </I18nextProvider>
    ) : null;

  const contentClass = `${style.modal_content} ${props.className} ${props.className}_content`;

  const overlayClass =
    `${style.modal_overlay} ${props.notebookExpanded?style.notebook_expanded:null} ${props.fullScreen?style.full_screen:null} ${props.className}_overlay`;

  return (
    <ReactModal
      aria={{
        label: props.ariaLabel,
      }}
      className={contentClass}
      overlayClassName={overlayClass}
      isOpen={props.isOpen}
      onRequestClose={props.close}
      shouldCloseOnOverlayClick={props.closeOnOverlayClick}>
      <IFrameFocusManager>
        {renderCloseButton()}
        {props.children}
      </IFrameFocusManager>
    </ReactModal>
  );
}

FullscreenModal.propTypes = {
  /**
   * Boolean set/reset to open/close modal
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * Fuction to close modal
   */
  close: PropTypes.func,
  /**
   * Component/Components to display on Modal
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * Close Modal window when cliked on overlay
   */
  closeOnOverlayClick: PropTypes.bool,
  /**
   * ClassName for overlay and content tags
   */
  className: PropTypes.string,
  /**
   * Show closeButton or not
   */
  closeButton: PropTypes.bool,
  /**
   * Notebook area expanded state
   */
  notebookExpanded: PropTypes.bool,
  /**
   * Notebook area full-screen state
   */
  fullScreen: PropTypes.bool,
};

FullscreenModal.defaultProps = {
  isOpen: false,
  closeOnOverlayClick: false,
  className: '',
  closeButton: false,
  notebookExpanded: false,
  fullScreen: false
};
